import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

import { AppUtils } from '../../shared/helpers/app.utils';

@Injectable()
export class AuthGuard {

    constructor(
        private readonly router: Router,
        private readonly appUtils: AppUtils
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
        if (this.appUtils.isUserAuthenticated()) {
            return true;
        }
        this.router.navigate(['/auth/sign-in'], { queryParams: { returnUrl: state.url } });
        return false;
    }
}